import buildAsyncCall from './asyncCall'
import * as Helpers from './helpers'

const Types = {
    DASHBOARD_WOW_BUTTONS: {
        request: 'DASHBOARD_WOW_BUTTONS##REQUEST',
        success: 'DASHBOARD_WOW_BUTTONS##SUCCESS',
        failure: 'DASHBOARD_WOW_BUTTONS##FAILURE',
    },
    DASHBOARD_WOW_DWELLTIME: {
        request: 'DASHBOARD_WOW_DWELLTIME##REQUEST',
        success: 'DASHBOARD_WOW_DWELLTIME##SUCCESS',
        failure: 'DASHBOARD_WOW_DWELLTIME##FAILURE',
    },
    DASHBOARD_WOW_DWELLTIMELINE: {
        request: 'DASHBOARD_WOW_DWELLTIMELINE##REQUEST',
        success: 'DASHBOARD_WOW_DWELLTIMELINE##SUCCESS',
        failure: 'DASHBOARD_WOW_DWELLTIMELINE##FAILURE',
    },
    DASHBOARD_WOW_DWELLTIMELINE_PRODUCT: {
        request: 'DASHBOARD_WOW_DWELLTIMELINE_PRODUCT##REQUEST',
        success: 'DASHBOARD_WOW_DWELLTIMELINE_PRODUCT##SUCCESS',
        failure: 'DASHBOARD_WOW_DWELLTIMELINE_PRODUCT##FAILURE',
    },
    DASHBOARD_WOW_SESSIONS_COUNT: {
        request: 'DASHBOARD_WOW_SESSIONS_COUNT##REQUEST',
        success: 'DASHBOARD_WOW_SESSIONS_COUNT##SUCCESS',
        failure: 'DASHBOARD_WOW_SESSIONS_COUNT##FAILURE',
    },
    DASHBOARD_WOW_INSTALLATIONS_TOP: {
        request: 'DASHBOARD_WOW_INSTALLATIONS_TOP##REQUEST',
        success: 'DASHBOARD_WOW_INSTALLATIONS_TOP##SUCCESS',
        failure: 'DASHBOARD_WOW_INSTALLATIONS_TOP##FAILURE',
    },
    DASHBOARD_WOW_MEDIA_TOP: {
        request: 'DASHBOARD_WOW_MEDIA_TOP##REQUEST',
        success: 'DASHBOARD_WOW_MEDIA_TOP##SUCCESS',
        failure: 'DASHBOARD_WOW_MEDIA_TOP##FAILURE',
    },
    DASHBOARD_WOW_STORES_TOP: {
        request: 'DASHBOARD_WOW_STORES_TOP##REQUEST',
        success: 'DASHBOARD_WOW_STORES_TOP##SUCCESS',
        failure: 'DASHBOARD_WOW_STORES_TOP##FAILURE',
    },
}

function fetchWowButtons(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('wow/buttons', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_WOW_BUTTONS.request, Types.DASHBOARD_WOW_BUTTONS.success, Types.DASHBOARD_WOW_BUTTONS.failure],
    })
}

function fetchWowDwellTime(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('wow/dwelltime', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_WOW_DWELLTIME.request, Types.DASHBOARD_WOW_DWELLTIME.success, Types.DASHBOARD_WOW_DWELLTIME.failure],
    })
}

function fetchWowDwellTimeline(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('wow/dwelltime/timeline', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_WOW_DWELLTIMELINE.request, Types.DASHBOARD_WOW_DWELLTIMELINE.success, Types.DASHBOARD_WOW_DWELLTIMELINE.failure],
    })
}

function fetchWowDwellTimelineProduct(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('wow/dwelltime/timeline/products', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_WOW_DWELLTIMELINE_PRODUCT.request,
            Types.DASHBOARD_WOW_DWELLTIMELINE_PRODUCT.success,
            Types.DASHBOARD_WOW_DWELLTIMELINE_PRODUCT.failure,
        ],
    })
}

function fetchWowSessionCount(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('wow/sessionscount', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_WOW_SESSIONS_COUNT.request, Types.DASHBOARD_WOW_SESSIONS_COUNT.success, Types.DASHBOARD_WOW_SESSIONS_COUNT.failure],
    })
}

function fetchWowTopInstallations(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('wow/installations/top', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_WOW_INSTALLATIONS_TOP.request, Types.DASHBOARD_WOW_INSTALLATIONS_TOP.success, Types.DASHBOARD_WOW_INSTALLATIONS_TOP.failure],
    })
}

function fetchWowTopMedia(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('wow/media/top', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_WOW_MEDIA_TOP.request, Types.DASHBOARD_WOW_MEDIA_TOP.success, Types.DASHBOARD_WOW_MEDIA_TOP.failure],
    })
}

function fetchWowStoresTop(from, to) {
    return async (dispatch) => {
        const mainFetch = await dispatch(
            buildAsyncCall({
                endpoint: Helpers.buildUrl('wow/stores/top', from, to),
                method: 'GET',
                types: [Types.DASHBOARD_WOW_STORES_TOP.request, Types.DASHBOARD_WOW_STORES_TOP.success, Types.DASHBOARD_WOW_STORES_TOP.failure],
            })
        )
        const { type, payload } = mainFetch

        if (type !== Types.DASHBOARD_WOW_STORES_TOP.success) {
            return mainFetch
        }

        const promises = await Promise.all(payload.map(({ store_code: storeCode }) => dispatch(Helpers.fetchStore(storeCode))))

        return [mainFetch, ...promises]
    }
}

export {
    Types,
    fetchWowButtons,
    fetchWowDwellTime,
    fetchWowDwellTimeline,
    fetchWowDwellTimelineProduct,
    fetchWowSessionCount,
    fetchWowStoresTop,
    fetchWowTopInstallations,
    fetchWowTopMedia,
}
